var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isShown)?_c('span',{staticClass:"v-estimate-status",style:(`color:${_vm.status?.color};background:${_vm.status?.background};`)},[_vm._v(" "+_vm._s(_vm.status.label)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }